<script setup lang="ts">
import GradeCalculationTagExcludedIcon from '@/assets/icons/gradeCalculation/GradeCalculationTagExcludedIcon.vue';
import GradeCalculationTagHighIcon from '@/assets/icons/gradeCalculation/GradeCalculationTagHighIcon.vue';
import GradeCalculationTagHigherIcon from '@/assets/icons/gradeCalculation/GradeCalculationTagHigherIcon.vue';
import GradeCalculationTagLowerIcon from '@/assets/icons/gradeCalculation/GradeCalculationTagLowerIcon.vue';
import { GradeCalculationTagKey } from 'common/enum/grade.calculation.enum';
import { computed, toRefs } from 'vue';

const props = withDefaults(
  defineProps<{
    tagKey?: string | null;
    reserveSpace?: boolean;
    size?: 'sm' | 'md';
  }>(),
  {
    tagKey: null,
    reserveSpace: false,
    size: 'md',
  },
);
const { tagKey, reserveSpace, size } = toRefs(props);

const normalizedTagKey = computed(() => (tagKey.value ?? GradeCalculationTagKey.DEFAULT).toLowerCase());
const isDefault = computed(() => normalizedTagKey.value === GradeCalculationTagKey.DEFAULT);
const isHigh = computed(() => normalizedTagKey.value === GradeCalculationTagKey.HIGH);
const isHigher = computed(() => normalizedTagKey.value === GradeCalculationTagKey.HIGHER);
const isLower = computed(() => normalizedTagKey.value === GradeCalculationTagKey.LOWER);
const isExcluded = computed(() => normalizedTagKey.value === GradeCalculationTagKey.EXCLUDED);
</script>

<template>
  <div
    v-if="!isDefault || reserveSpace"
    :class="['relative flex shrink-0 items-center justify-center', size === 'sm' ? 'size-icon-xs' : 'size-icon-md']"
  >
    <GradeCalculationTagHighIcon v-if="isHigh" class="size-full text-papaya" />
    <GradeCalculationTagHigherIcon v-else-if="isHigher" class="size-full text-mandarine" />
    <GradeCalculationTagLowerIcon v-else-if="isLower" class="size-full text-secondary" />
    <GradeCalculationTagExcludedIcon v-else-if="isExcluded" class="size-full text-secondary" />
  </div>
</template>
